import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  PaSliderRangeComponent,
  SliderRangeValue,
} from 'src/app/shared/ui-kit/pa-slider-range/pa-slider-range.component';

@Component({
  selector: 'app-slide-range-view',
  standalone: true,
  imports: [ReactiveFormsModule, PaSliderRangeComponent],
  templateUrl: './slide-range-view.component.html',
  styleUrls: ['./slide-range-view.component.scss'],
})
export class SlideRangeViewComponent {
  readonly timeRangeControl = new FormControl<SliderRangeValue>({
    lower: 9,
    upper: 21,
  });

  readonly timeNoInputControl = new FormControl<SliderRangeValue>({
    lower: 8,
    upper: 22,
  });

  readonly numberRangeControl = new FormControl<SliderRangeValue>({
    lower: 20,
    upper: 80,
  });

  readonly currencyRangeControl = new FormControl<SliderRangeValue>({
    lower: 0,
    upper: 3000000,
  });

  readonly singleNumberControl = new FormControl<number>(45);
  readonly singleTimeControl = new FormControl<number>(12);
  readonly disabledRangeControl = new FormControl<SliderRangeValue>({
    lower: 150000,
    upper: 250000,
  });
}
